module.exports = __webpack_public_path__ + "img/hr-heated-corner-up-right-4.f66525ee.png";